var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 48.5238,
    rx: 4.5,
    stroke: "#FFF5EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6668 39.2072H10.4167V18.5723H16.6668V39.2072ZM39.5834 39.2072H33.3334V28.184C33.3334 25.3116 32.3001 23.8816 30.2522 23.8816C28.6293 23.8816 27.6001 24.6823 27.0834 26.2856V39.2072H20.8334C20.8334 39.2072 20.9168 20.6358 20.8334 18.5723H25.7668L26.148 22.6992H26.2772C27.5584 20.6358 29.6063 19.2367 32.4147 19.2367C34.5501 19.2367 36.2772 19.8248 37.5959 21.3023C38.923 22.7818 39.5834 24.7669 39.5834 27.5546V39.2072Z",
    fill: "#FFF5EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5417 16.5088C15.3251 16.5088 16.7708 15.123 16.7708 13.4136C16.7708 11.7041 15.3251 10.3184 13.5417 10.3184C11.7582 10.3184 10.3125 11.7041 10.3125 13.4136C10.3125 15.123 11.7582 16.5088 13.5417 16.5088Z",
    fill: "#FFF5EE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIn);
export default __webpack_public_path__ + "static/media/icon-in.0feb3dff58b0c9c9edb718190d3c8a22.svg";
export { ForwardRef as ReactComponent };